import { render, staticRenderFns } from "./ExportResourcesModal.vue?vue&type=template&id=51bbf7d3"
import script from "./ExportResourcesModal.vue?vue&type=script&lang=js"
export * from "./ExportResourcesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports